<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 col-md-3 col-lg-3 col-xl-4 custom-width-desktop">
        <div class="scrollable-container">
          <div class="scrollable-div bg-light shadow-lg rounded-lg p-2">
            <div class="text-center">
              <h2>
                Der Heißluftfritteusen-Finder
                <img
                  src="https://findingo.de/wp-content/uploads/2024/12/cropped-logo_small.png"
                  class="img-fluid"
                  style="width: 20%;"
                  alt="Findingo Logo"
                >
              </h2>

              <h4 class="h4 mt-2" style="font-family:Open Sans,Arial,sans-serif">
                Zu kompliziert? Dann probiere die
                <a
                  href="https://findingo.de/heissluftfritteusen/heissluftfritteusen-kaufberatung/"
                  style="font-size:1.3rem;color: #007bff; text-decoration: underline; position: relative"
                >
                  smarte Airfryer-Kaufberatung</a>
                <span
                  style="
                    background-color: #ff3b30;
                    color: white;
                    font-weight: bold;
                    font-size: 0.7rem;
                    padding: 1px 5px;
                    border-radius: 6px;
                    position: relative;
                    top: -0.6em;
                    margin-left: 4px;
                  "
                >NEW</span>
                aus!
              </h4>
            </div>

            <form method="GET" name="finder-form" id="finder-form" @change="onFormChange">
              <div class="formContent p-2">
                <div class="row row-cols-2">
                  <div class="ml-2 mb-3 w-[80%]">
                    <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">
                      Hersteller
                    </span>
                    <select
                      v-model="filters.marke"
                      id="marke"
                      name="marke"
                      class="spanSelectField form-select form-select-lg mb-1"
                    >
                      <option value="Alle">Alle</option>
                      <option v-for="brand in brandOptions" :key="brand" :value="brand">
                        {{ brand }}
                      </option>
                    </select>
                  </div>

                                    <div class="ml-2 mb-3 w-[80%]">
                    <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">
                      Gerätetyp
                    </span>
                    <select
                      v-model="filters.produkttyp"
                      id="produkttyp"
                      name="produkttyp"
                      class="spanSelectField form-select form-select-lg mb-1"
                    >
                      <option value="Alle">Alle</option>
                      <option value="Heißluftfritteuse" selected>Heißluftfritteuse</option>
                      <option value="Fritteuse">Klassische Fritteuse</option>
                    </select>
                  </div>

                                            <div class="ml-2 mb-3 w-[80%]">
          <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">
            Kammern
          </span>
          <select
            v-model="filters.bauart"
            id="bauart"
            name="bauart"
            class="spanSelectField form-select form-select-lg mb-1"
          >
            <option value="Alle">Alle</option>
            <option value="Einzelbild">Eine Kammer</option>
            <option value="Doppel">Zwei Kammern</option>
          </select>
        </div>

                          <div class="ml-2 mb-3 w-[80%]">
          <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">
            Größe / Personen
          </span>
          <select
            v-model="filters.fassungsvermoegenKategorie"
            id="fassungsvermoegenKategorie"
            name="fassungsvermoegenKategorie"
            class="spanSelectField form-select form-select-lg mb-1"
            @change="applyCapacityPreset"
          >
            <option value="Alle">Alle Größen</option>
            <option value="kompakt">Kompakt bis 4 l – Singles & Paare</option>
            <option value="alltag">4–6 l – Alltag für 2–4 Personen</option>
            <option value="familie">6–8 l – Familie & größere Portionen</option>
            <option value="gross">Ab 8 l – große Familien & Meal Prep</option>
          </select>
        </div>

                <div class="ml-2 mb-3 w-[80%]">
          <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">
            Sichtfenster
          </span>
          <select
            v-model="filters.sichtfenster"
            id="sichtfenster"
            name="sichtfenster"
            class="spanSelectField form-select form-select-lg mb-1"
          >
            <option value="Alle">Alle</option>
            <option value="1">Ja</option>
            <option value="0">Nein</option>
          </select>
        </div>

                </div>

                <h5 class="mt-4">Preis</h5>
                <div class="mt-5" id="slider"></div>
                <input type="text" id="minCost" readonly hidden>
                <input type="text" id="maxCost" readonly hidden>


<div class="mt-3">
  <details>
    <summary>Design & Maße</summary>
    <div class="container">
      <div class="row row-cols-2">
                <div class="ml-2 mb-3 w-[80%]">
          <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">
            Farbe
          </span>
          <select
            v-model="filters.produktfarbe"
            id="produktfarbe"
            name="produktfarbe"
            class="spanSelectField form-select form-select-lg mb-1"
          >
            <option value="Alle">Alle Farben</option>
            <option value="Schwarz">Schwarz</option>
            <option value="Weiß">Weiß</option>
            <option value="Silber">Silber</option>
            <option value="Edelstahl">Edelstahl</option>
          </select>
        </div>

                <div class="ml-2 mb-3 w-[80%]">
          <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">
            Material
          </span>
          <select
            v-model="filters.material"
            id="material"
            name="material"
            class="spanSelectField form-select form-select-lg mb-1"
          >
            <option value="Alle">Alle Materialien</option>
            <option value="Kunststoff">Kunststoff</option>
            <option value="Edelstahl">Edelstahl</option>
            <option value="Metall">Metall</option>
          </select>
        </div>

        <div class="ml-2 mb-3 w-[80%]">
          <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">
            Breite
          </span>
          <select
            v-model="filters.breiteKategorie"
            id="breiteKategorie"
            name="breiteKategorie"
            class="spanSelectField form-select form-select-lg mb-1"
          >
            <option value="Alle">Alle Breiten</option>
            <option value="schmal">Schmal bis 30 cm</option>
            <option value="mittel">Mittel 30–40 cm</option>
            <option value="breit">Breit ab 40 cm</option>
          </select>
        </div>

        <div class="ml-2 mb-3 w-[80%]">
          <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">
            Tiefe
          </span>
          <select
            v-model="filters.tiefeKategorie"
            id="tiefeKategorie"
            name="tiefeKategorie"
            class="spanSelectField form-select form-select-lg mb-1"
          >
            <option value="Alle">Alle Tiefen</option>
            <option value="kompakt">Kompakt bis 35 cm</option>
            <option value="mittel">Mittel 35–45 cm</option>
            <option value="tief">Tief ab 45 cm</option>
          </select>
        </div>

        <div class="ml-2 mb-3 w-[80%]">
          <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">
            Höhe
          </span>
          <select
            v-model="filters.hoeheKategorie"
            id="hoeheKategorie"
            name="hoeheKategorie"
            class="spanSelectField form-select form-select-lg mb-1"
          >
            <option value="Alle">Alle Höhen</option>
            <option value="niedrig">Niedrig bis 30 cm</option>
            <option value="mittel">Mittel 30–40 cm</option>
            <option value="hoch">Hoch ab 40 cm</option>
          </select>
        </div>

        <div class="ml-2 mb-3 w-[80%]">
          <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">
            Gewicht
          </span>
          <select
            v-model="filters.gewichtKategorie"
            id="gewichtKategorie"
            name="gewichtKategorie"
            class="spanSelectField form-select form-select-lg mb-1"
          >
            <option value="Alle">Alle Gewichte</option>
            <option value="leicht">Leicht bis 5 kg</option>
            <option value="mittel">Mittel 5–8 kg</option>
            <option value="schwer">Schwer ab 8 kg</option>
          </select>
        </div>
      </div>
    </div>
  </details>
</div>

<div class="mt-3">
  <details>
    <summary>Leistung & Temperatur</summary>
    <div class="container">
      <div class="row row-cols-2">

        <div class="ml-2 mb-3 w-[80%]">
          <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">
            Leistung
          </span>
          <select
            v-model="filters.leistungKategorie"
            id="leistungKategorie"
            name="leistungKategorie"
            class="spanSelectField form-select form-select-lg mb-1"
          >
            <option value="Alle">Alle Leistungen</option>
            <option value="sparsam">Bis 1500 W</option>
            <option value="normal">1500–2000 W</option>
            <option value="stark">Ab 2000 W</option>
          </select>
        </div>

        <div class="ml-2 mb-3 w-[80%]">
          <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">
            Temperaturbereich
          </span>
          <select
            v-model="filters.temperaturKategorie"
            id="temperaturKategorie"
            name="temperaturKategorie"
            class="spanSelectField form-select form-select-lg mb-1"
          >
            <option value="Alle">Alle Temperaturbereiche</option>
            <option value="standard">Bis 200 °C</option>
            <option value="hoch">Über 200 °C</option>
          </select>
        </div>

        <div class="ml-2 mb-3 w-[80%]">
          <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">
            Temperatur regelbar
          </span>
          <select
            v-model="filters.regelbare_temperatur"
            id="regelbare_temperatur"
            name="regelbare_temperatur"
            class="spanSelectField form-select form-select-lg mb-1"
          >
            <option value="Alle">Alle</option>
            <option value="1">Ja</option>
            <option value="0">Nein</option>
          </select>
        </div>

      </div>
    </div>
  </details>
</div>

<div class="mt-3">
  <details>
    <summary>Bedienung & Sicherheit</summary>
    <div class="container">
      <div class="row row-cols-2">

        <div class="ml-2 mb-3 w-[80%]">
          <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">
            Display
          </span>
          <select
            v-model="filters.eingebautes_display"
            id="eingebautes_display"
            name="eingebautes_display"
            class="spanSelectField form-select form-select-lg mb-1"
          >
            <option value="Alle">Alle</option>
            <option value="1">Ja</option>
            <option value="0">Nein</option>
          </select>
        </div>

        <div class="ml-2 mb-3 w-[80%]">
          <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">
            Timer
          </span>
          <select
            v-model="filters.digital_zeitmesser"
            id="digital_zeitmesser"
            name="digital_zeitmesser"
            class="spanSelectField form-select form-select-lg mb-1"
          >
            <option value="Alle">Alle</option>
            <option value="1">Ja</option>
            <option value="0">Nein</option>
          </select>
        </div>

        <div class="ml-2 mb-3 w-[80%]">
          <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">
            Abschaltung
          </span>
          <select
            v-model="filters.automatische_abschaltung"
            id="automatische_abschaltung"
            name="automatische_abschaltung"
            class="spanSelectField form-select form-select-lg mb-1"
          >
            <option value="Alle">Alle</option>
            <option value="1">Ja</option>
            <option value="0">Nein</option>
          </select>
        </div>

        <div class="ml-2 mb-3 w-[80%]">
          <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">
            Rutschfeste Füße
          </span>
          <select
            v-model="filters.rutschfeste_fuesse"
            id="rutschfeste_fuesse"
            name="rutschfeste_fuesse"
            class="spanSelectField form-select form-select-lg mb-1"
          >
            <option value="Alle">Alle</option>
            <option value="1">Ja</option>
            <option value="0">Nein</option>
          </select>
        </div>

      </div>
    </div>
  </details>
</div>

                <div class="form-footer mt-2">
                  <button type="button" class="btn btn-secondary btn-sm px-4 py-2" @click="resetFilters">
                    Auswahl zurücksetzen
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-9 col-lg-9 col-xl-8">
        <div v-if="loading" class="loading-spinner"></div>

        <div v-else class="pt-4">
          <div class="row g-4">
            <div
              v-for="(product, index) in products"
              :key="cardKey(product, index)"
              class="col-12 col-sm-6 col-lg-4 mb-4"
              :class="getCardAnimationClass(index)"
            >
              <div class="card" :class="{ 'is-flipped': isFlipped(cardKey(product, index)) }">
                <div class="card-front">
                  <h5 class="card-title text-center mt-3 mx-5">
                    {{ productTitle(product) }}
                  </h5>

                  <PicCarousel :product="normalizedProduct(product)" />

                  <div class="card-body">
                    <div class="row">
                      <div class="col-12 col-sm-6">
                        <div class="d-flex flex-column">
                          <span class="label-data-front mx-2 mt-2">Fassungsvermögen</span>
                          <span class="ml-2">{{ formatLiter(primaryCapacity(product)) }}</span>

                          <span class="label-data-front mx-2">Personen</span>
                          <span class="ml-2">{{ formatPeople(product.anzahl_der_personen) }}</span>

                        </div>
                      </div>

                      <div class="col-12 col-sm-6">
                        <div class="d-flex flex-column">

                          <span class="label-data-front mx-2 mt-2">Temperatur</span>
                          <span class="ml-2">{{ temperatureRange(product) }}</span>

                          <span class="label-data-front mx-2">Leistung</span>
                          <span class="ml-2">{{ formatNumber(product.leistung_w, ' W') }}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <button class="datasheet-button" @click="flipCard(cardKey(product, index))">
                    <i class="fa-solid fa-rotate-right icon-margin-right"></i>
                    Daten aufklappen
                  </button>

                  <div class="card-footer">
                    <div class="footer-content d-flex justify-content-between">
                      <div class="shop-info">
                        <span class="no_click" style="text-align: left;">Amazon.de</span>
                        <div class="text-muted small" style="text-align: left; font-size: 12px;">
                          aktualisiert: {{ product.updated_time }}
                        </div>
                      </div>

                      <div class="amazon-info">
                        <div class="pb-2">
                          <div class="no_click pb-1" style="text-align:left;">
                            <img
                              class="shop-icon"
                              src="/wp-content/plugins/airfryer-finder/amazon_icon.png"
                              alt="Amazon Logo"
                              style="margin-right: 4px;"
                            />
                            <span class="mr-2">| </span>
                            <span class="price">{{ formatPrice(product.preisAmazonNeu || product.preis_amazon_neu || product.preisAmazon || product.preis_amazon) }}</span><br />
                            <a :href="product.amazon_url" target="_blank" rel="sponsored nofollow noopener">
                              <button class="btn12 px-3 py-1">zum Angebot*</button>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-back">
                  <div class="card-body">
                    <DatenblattMod :product="normalizedProduct(product)" />
                  </div>
                  <button class="datasheet-button" @click="flipCard(cardKey(product, index))">
                    <i class="fa-solid fa-rotate-left icon-margin-right"></i>
                    Zurück zur Übersicht
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div v-if="!products.length" class="text-center mt-5">
            <h4>Keine passenden Airfryer gefunden</h4>
            <p>Ändere deine Filter, um mehr Produkte zu sehen.</p>
          </div>
        </div>
      </div>

      <div class="text-center">
        <button class="datasheet-button" @click="updateAirfryer">
          Mehr Airfryer laden
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import PicCarousel from "./PicCarousel.vue";
import DatenblattMod from "./DatenblattMod.vue";

const capacityPresets = {
  Alle: {
    minFassungsvermoegen: "0",
    maxFassungsvermoegen: "30",
  },
  kompakt: {
    minFassungsvermoegen: "0",
    maxFassungsvermoegen: "4",
  },
  alltag: {
    minFassungsvermoegen: "4",
    maxFassungsvermoegen: "6",
  },
  familie: {
    minFassungsvermoegen: "6",
    maxFassungsvermoegen: "8",
  },
  gross: {
    minFassungsvermoegen: "8",
    maxFassungsvermoegen: "30",
  },
};

const widthPresets = {
  Alle: {
    minBreite: "0",
    maxBreite: "9999",
  },
  schmal: {
    minBreite: "0",
    maxBreite: "300",
  },
  mittel: {
    minBreite: "300",
    maxBreite: "400",
  },
  breit: {
    minBreite: "400",
    maxBreite: "9999",
  },
};

const depthPresets = {
  Alle: {
    minTiefe: "0",
    maxTiefe: "9999",
  },
  kompakt: {
    minTiefe: "0",
    maxTiefe: "350",
  },
  mittel: {
    minTiefe: "350",
    maxTiefe: "450",
  },
  tief: {
    minTiefe: "450",
    maxTiefe: "9999",
  },
};

const heightPresets = {
  Alle: {
    minHoehe: "0",
    maxHoehe: "9999",
  },
  niedrig: {
    minHoehe: "0",
    maxHoehe: "300",
  },
  mittel: {
    minHoehe: "300",
    maxHoehe: "400",
  },
  hoch: {
    minHoehe: "400",
    maxHoehe: "9999",
  },
};

const weightPresets = {
  Alle: {
    minGewicht: "0",
    maxGewicht: "99",
  },
  leicht: {
    minGewicht: "0",
    maxGewicht: "5",
  },
  mittel: {
    minGewicht: "5",
    maxGewicht: "8",
  },
  schwer: {
    minGewicht: "8",
    maxGewicht: "99",
  },
};

const powerPresets = {
  Alle: {
    minLeistung: "0",
    maxLeistung: "4000",
  },
  sparsam: {
    minLeistung: "0",
    maxLeistung: "1500",
  },
  normal: {
    minLeistung: "1500",
    maxLeistung: "2000",
  },
  stark: {
    minLeistung: "2000",
    maxLeistung: "4000",
  },
};

const temperaturePresets = {
  Alle: {
    minTemperaturMin: "0",
    maxTemperaturMin: "999",
    minTemperaturMax: "0",
    maxTemperaturMax: "999",
  },
  standard: {
    minTemperaturMin: "0",
    maxTemperaturMin: "999",
    minTemperaturMax: "0",
    maxTemperaturMax: "200",
  },
  hoch: {
    minTemperaturMin: "0",
    maxTemperaturMin: "999",
    minTemperaturMax: "201",
    maxTemperaturMax: "999",
  },
};

const defaultFilters = () => ({
  marke: "Alle",
  brand: "Alle",
  release_date: "Alle",

  produkttyp: "Heißluftfritteuse",
  bauart: "Alle",

  fassungsvermoegenKategorie: "Alle",
  minFassungsvermoegen: "0",
  maxFassungsvermoegen: "30",

  breiteKategorie: "Alle",
  tiefeKategorie: "Alle",
  hoeheKategorie: "Alle",
  gewichtKategorie: "Alle",

  minBreite: "0",
  maxBreite: "9999",
  minTiefe: "0",
  maxTiefe: "9999",
  minHoehe: "0",
  maxHoehe: "9999",
  minGewicht: "0",
  maxGewicht: "99",

  produktfarbe: "Alle",
  material: "Alle",

  leistungKategorie: "Alle",
  minLeistung: "0",
  maxLeistung: "4000",

  temperaturKategorie: "Alle",
  minTemperaturMin: "0",
  maxTemperaturMin: "999",
  minTemperaturMax: "0",
  maxTemperaturMax: "999",

  regelbare_temperatur: "Alle",
  eingebautes_display: "Alle",
  digital_zeitmesser: "Alle",
  automatische_abschaltung: "Alle",
  sichtfenster: "Alle",
  rutschfeste_fuesse: "Alle",

  minPrice: "0",
  maxPrice: "500",
});

export default {
  name: "AirfryerFinderApp",

  components: {
    PicCarousel,
    DatenblattMod,
  },

  data() {
    return {
      apiUrl: "/wp-content/plugins/airfryer-finder/testNeuFinderApp.php",
      flippedCards: [],
      products: [],
      loading: false,
      productsPerLoad: 9,
      loadedProductIndex: 9,
      filters: defaultFilters(),
      brandOptions: [
        "Ariete",
        "Braun",
        "Cosori",
        "Gorenje",
        "Grundig",
        "Hisense",
        "Kenwood",
        "MEDION",
        "NutriBullet",
        "Philips",
        "Sharp",
        "Tefal",
        "TORNADO",
        "Unold",
        "WMF",
      ],
    };
  },

  methods: {
    initializeSlider() {
      this.createPriceSlider();
    },

    createPriceSlider() {
      const slider = document.getElementById("slider");
      if (!slider || typeof noUiSlider === "undefined" || typeof wNumb === "undefined") return;

      if (slider.noUiSlider) {
        slider.noUiSlider.destroy();
      }

      noUiSlider.create(slider, {
        connect: true,
        behaviour: "tap",
        start: [this.filters.minPrice, this.filters.maxPrice],
        format: wNumb({
          decimals: 0,
          suffix: " (€)",
        }),
        tooltips: true,
        range: {
          min: [0],
          "70%": [200, 10],
          "90%": [300, 25],
          max: [350],
        },
      });

      slider.noUiSlider.on("change", () => {
        const values = slider.noUiSlider.get();
        this.filters.minPrice = this.parseSliderValue(values[0]);
        this.filters.maxPrice = this.parseSliderValue(values[1]);
        this.fetchProducts();
      });
    },

    parseSliderValue(value) {
      return String(value)
        .replace("€", "")
        .replace("(", "")
        .replace(")", "")
        .trim()
        .replace(",", ".")
        .replace(/[^0-9.]/g, "");
    },

    applyCapacityPreset() {
      this.applyAllPresets();
    },

    applyAllPresets() {
      const capacity = capacityPresets[this.filters.fassungsvermoegenKategorie] || capacityPresets.Alle;
      const width = widthPresets[this.filters.breiteKategorie] || widthPresets.Alle;
      const depth = depthPresets[this.filters.tiefeKategorie] || depthPresets.Alle;
      const height = heightPresets[this.filters.hoeheKategorie] || heightPresets.Alle;
      const weight = weightPresets[this.filters.gewichtKategorie] || weightPresets.Alle;
      const power = powerPresets[this.filters.leistungKategorie] || powerPresets.Alle;
      const temperature = temperaturePresets[this.filters.temperaturKategorie] || temperaturePresets.Alle;

      Object.assign(
        this.filters,
        capacity,
        width,
        depth,
        height,
        weight,
        power,
        temperature
      );
    },

    onFormChange() {
      this.applyAllPresets();
      this.fetchProducts();
    },

    buildRequestFilters() {
      this.applyAllPresets();

      return {
        ...this.filters,
        brand: this.filters.marke,

        minBreiteMm: this.filters.minBreite,
        maxBreiteMm: this.filters.maxBreite,

        minTiefeMm: this.filters.minTiefe,
        maxTiefeMm: this.filters.maxTiefe,

        minHoeheMm: this.filters.minHoehe,
        maxHoeheMm: this.filters.maxHoehe,

        minGewichtKg: this.filters.minGewicht,
        maxGewichtKg: this.filters.maxGewicht,

        minTemperaturMinC: this.filters.minTemperaturMin,
        maxTemperaturMinC: this.filters.maxTemperaturMin,

        minTemperaturMaxC: this.filters.minTemperaturMax,
        maxTemperaturMaxC: this.filters.maxTemperaturMax,
      };
    },

    fetchProducts() {
      this.loading = true;
      this.loadedProductIndex = 9;

      $.ajax({
        url: this.apiUrl,
        method: "POST",
        dataType: "json",
        data: {
          filters: this.buildRequestFilters(),
          limit: this.loadedProductIndex,
        },
        success: (response) => {
          this.loading = false;
          this.products = this.extractProducts(response);
          this.flippedCards = [];
        },
        error: (xhr, status, error) => {
          this.loading = false;
          console.error("Airfryer konnten nicht geladen werden:", status, error, xhr);
        },
      });
    },

    extractProducts(response) {
      if (Array.isArray(response)) return response;
      if (response && Array.isArray(response.filteredProducts)) return response.filteredProducts;
      if (response && Array.isArray(response.products)) return response.products;
      return [];
    },

    updateAirfryer() {
      this.loadedProductIndex += this.productsPerLoad;

      $.ajax({
        url: this.apiUrl,
        method: "POST",
        dataType: "json",
        data: {
          filters: this.buildRequestFilters(),
          limit: this.loadedProductIndex,
        },
        success: (response) => {
          this.products = this.extractProducts(response);
        },
        error: (xhr, status, error) => {
          console.error("Weitere Airfryer konnten nicht geladen werden:", status, error, xhr);
        },
      });
    },

    resetFilters() {
      this.filters = defaultFilters();
      this.flippedCards = [];

      this.$nextTick(() => {
        this.initializeSlider();
        this.fetchProducts();
      });
    },

    flipCard(cardId) {
      const cardIndex = this.flippedCards.indexOf(cardId);
      if (cardIndex === -1) {
        this.flippedCards.push(cardId);
      } else {
        this.flippedCards.splice(cardIndex, 1);
      }
    },

    isFlipped(cardId) {
      return this.flippedCards.includes(cardId);
    },

    cardKey(product, index) {
      const id = product.id || product.icecat_id || product.asin || product.ean || product.ean_icecat || "airfryer";
      return `${id}-${index}`;
    },

    getCardAnimationClass(index) {
      const delay = (index + 1) * 25;
      return `animate__animated animate__fadeInUp animate__${delay}ms`;
    },

    normalizedProduct(product) {
      return {
        ...product,
        preisAmazonNeu: product.preisAmazonNeu || product.preis_amazon_neu,
        preisAmazon: product.preisAmazon || product.preis_amazon,
        picVariants: product.picVariants || product.pic_variants,
        amazonNamenSuche: product.amazonNamenSuche || product.amazon_namen_suche,
      };
    },

    productTitle(product) {
      if (product.amazonNamenSuche) return product.amazonNamenSuche;
      if (product.amazon_namen_suche) return product.amazon_namen_suche;
      if (product.titel) return product.titel;

      const fallback = [product.marke, product.artikel_nummer].filter(Boolean).join(" ");
      return fallback || "Airfryer";
    },

    toNumber(value) {
      if (value === null || value === undefined || value === "") return null;
      const normalized = String(value)
        .replace(/[^0-9,.-]/g, "")
        .replace(",", ".");
      const number = Number.parseFloat(normalized);
      return Number.isFinite(number) ? number : null;
    },

    formatNumber(value, suffix = "", decimals = 0) {
      const number = this.toNumber(value);
      if (number === null || number === 0) return "keine Angabe";

      return `${number.toLocaleString("de-DE", {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      })}${suffix}`;
    },

    formatLiter(value) {
      const number = this.toNumber(value);
      if (number === null || number === 0) return "keine Angabe";

      const decimals = Number.isInteger(number) ? 0 : 1;
      return `${number.toLocaleString("de-DE", {
        minimumFractionDigits: decimals,
        maximumFractionDigits: 1,
      })} l`;
    },

    formatPrice(value) {
      const number = this.toNumber(value);
      if (number === null || number === 0) return "Preis prüfen";

      return number.toLocaleString("de-DE", {
        style: "currency",
        currency: "EUR",
      });
    },

    formatBauart(value) {
      if (value === "Einzelbild") return "Eine Kammer";
      if (value === "Doppel") return "Zwei Kammern";
      return value || "keine Angabe";
    },

    formatPeople(value) {
      const number = this.toNumber(value);
      if (number === null || number === 0) return "keine Angabe";
      return `${number.toLocaleString("de-DE")} Personen`;
    },

    primaryCapacity(product) {
      return product.fassungsvermoegen_l || product.schuesselkapazitaet_l || product.oel_fuellmenge_l;
    },

    temperatureRange(product) {
      const min = this.toNumber(product.temperatur_min_c);
      const max = this.toNumber(product.temperatur_max_c);

      if (min && max) return `${min.toLocaleString("de-DE")}–${max.toLocaleString("de-DE")} °C`;
      if (max) return `bis ${max.toLocaleString("de-DE")} °C`;
      if (min) return `ab ${min.toLocaleString("de-DE")} °C`;
      return "keine Angabe";
    },

    dimensions(product) {
      const width = this.toNumber(product.breite_mm || product.abmessungen_breite_mm);
      const depth = this.toNumber(product.tiefe_mm || product.abmessungen_tiefe_mm);
      const height = this.toNumber(product.hoehe_mm || product.abmessungen_hoehe_mm);

      if (width && depth && height) {
        return `${width.toLocaleString("de-DE")} × ${depth.toLocaleString("de-DE")} × ${height.toLocaleString("de-DE")} mm`;
      }

      return "keine Angabe";
    },
  },

  mounted() {
    this.initializeSlider();
    this.fetchProducts();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
    /* Stile für die Slider-Checkboxen */
    .form-check-input[type="checkbox"].form-check-input {
        width: 40px; /* Ändere die Breite nach Bedarf */
        height: 20px; /* Ändere die Höhe nach Bedarf */
    }

    /* Optional: Ändere den Rand und die Polsterung für ein besser aussehendes Design */
    .form-check-input[type="checkbox"].form-check-input {
        margin-right: 10px;
        padding: 5px;
    }
  
    .bg-cs-color{
      background-color: #c2ab9282;
    }

    .spanField{
      border-radius: 10px 10px 0 0;
    }

    .spanSelectField{
      border-radius: 0 10px 10px 10px;
      border-width: 1px;
      border-color: #DDD1C5
    }

    .spanSelectField:focus {
  outline: none; /* Entfernt den Standard-Fokus-Rahmen */
  border-color: #c2ab9282; /* Ändert die Farbe des Rahmens */
  box-shadow: 0 0 5px #c2ab9282; /* Ändert den Schatten */
}

.flip-card-3D-wrapper {
  perspective: 1000px;
}

.datasheet-button{

}

.card {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin: 5px;
  text-align: center;
  transform-style: preserve-3d;
  transition: transform 0.5s;
  display:flex;
}



.card.is-flipped {
  transform: rotateY(180deg);
}

.card-front,
.card-back {
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
}

.card-body{
  padding:0px;
}

.card-back {
  transform: rotateY(180deg);
  position:absolute;
  /* This background is !essential! to make the flip work on firefox */
  background-color: #fff;
}

.label-data-front {
color: #999

}

@media (min-width: 992px) {
  .custom-width-desktop {
    width: 25%;
  }
}

.scrolly {
    max-height: 900; 
    overflow-y: auto; 
     border: 1px solid #ccc;
}

.icon-margin-right {
            margin-right: 8px; /* Abstand nach rechts */
        }

.loading-spinner {
            border: 16px solid #f3f3f3; /* Light grey */
            border-top: 16px solid #c2ab9282; /* Blue */
            border-radius: 50%;
            width: 120px;
            height: 120px;
            animation: spin 2s linear infinite;
            margin: auto;
        }

        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }
.shop-info{
  text-align: left;
  align-content: center;
}

.scrollable-div::-webkit-scrollbar-track {
  background-color: #f1f1f1; /* Helle graue Farbe für den Track /
  border-radius: 10px; /* Abgerundete Ecken */
}


.scrollable-div::-webkit-scrollbar-thumb {
  background-color: #888;  
  border-radius: 10px; 
  border: 3px solid #f1f1f1; 
}


.scrollable-div::-webkit-scrollbar {
  width: 12px;  
}

.scrollable-div {
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;
}

  /* Standard Stil für kleine Bildschirme */
  .scrollable-container {
    height: auto !important;
    overflow-y: visible;
    position: static;
  }

  /* Stil für große Bildschirme */
  @media (min-width: 992px) {
    .scrollable-container {
      height: 1000px !important;
      overflow-y: auto;
      position: sticky;
      top: 0px;
    }
  }

  .btn12 {
    background-color: #fa890052;
  }
    .form-select-md-lg {
  padding: 0.375rem 0.65rem;       /* md: 0.375rem / lg: 0.75rem → hier 0.5rem */
  font-size: 1.2rem;           /* md: 1rem / lg: 1.25rem → hier 1.125rem */
  line-height: 1.5;
  border-radius: 0.25rem;        /* md: 0.25rem / lg: 0.3rem */
}
</style>


